import { render, staticRenderFns } from "./robot_gift.vue?vue&type=template&id=5fe37040&scoped=true"
import script from "./robot_gift.vue?vue&type=script&lang=js"
export * from "./robot_gift.vue?vue&type=script&lang=js"
import style0 from "./robot_gift.vue?vue&type=style&index=0&id=5fe37040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe37040",
  null
  
)

export default component.exports